import { ReducerRegistry } from 'store';
import {
  FETCH_TERMINAL_PRICE_ASYNC,
  FETCH_TERMINAL_PRICE_END_COMPLETE,
  FETCH_TERMINAL_PRICE_ASYNC_END,
  CREATE_TERMINAL_REQUEST_ASYNC,
  CREATE_TERMINAL_REQUEST_END_COMPLETE,
  CREATE_TERMINAL_REQUEST_ASYNC_END,
  FETCH_ALL_TERMINAL_START_ASYNC,
  FETCH_ALL_TERMINAL_END_ASYNC,
  FETCH_ALL_TERMINALS,
  FETCH_TERMINAL_REQUESTS,
  ACTIVATE_TERMINAL_ASYNC_START,
  ACTIVATE_TERMINAL_ASYNC_END,
  ACTIVATE_TERMINAL_REQUEST,
} from '../types';

const INIT_STATE = {
  terminalPrice: 30000,
  fetchingPrice: false,
  creatingTerminal: false,
  activatingTerminal: false,
  terminalInfo: {
    amount: 0,
    id: null,
    posRequestType: 'LEASE',
  },
  terminals: {
    data: [],
    pagination: { page: 1, limit: 6 },
    inProgress: false,
    error: '',
  },
  terminalRequests: {
    data: [],
    pagination: { page: 1, limit: 6 },
    inProgress: false,
    error: '',
  },
};

export const teamReducer = ReducerRegistry.register(
  'terminal',
  (state = INIT_STATE, { type, payload, subType }) => {
    switch (type) {
      case FETCH_TERMINAL_PRICE_ASYNC:
        return {
          ...state,
          fetchingPrice: true,
        };
      case FETCH_TERMINAL_PRICE_END_COMPLETE:
        return {
          ...state,
          fetchingPrice: false,
          terminalInfo: { ...payload },
        };
      case FETCH_TERMINAL_PRICE_ASYNC_END:
        return {
          ...state,
          fetchingPrice: false,
        };
      case CREATE_TERMINAL_REQUEST_ASYNC:
        return {
          ...state,
          creatingTerminal: true,
        };
      case CREATE_TERMINAL_REQUEST_END_COMPLETE:
        return {
          ...state,
          creatingTerminal: false,
        };
      case CREATE_TERMINAL_REQUEST_ASYNC_END:
        return {
          ...state,
          creatingTerminal: false,
        };
      case ACTIVATE_TERMINAL_ASYNC_START:
        return {
          ...state,
          activatingTerminal: true,
        };
      case ACTIVATE_TERMINAL_ASYNC_END:
        return {
          ...state,
          activatingTerminal: false,
        };
      case FETCH_ALL_TERMINALS:
        return {
          ...state,
          terminals: {
            ...state.terminals,
            data: payload.list,
            pagination: {
              ...state.terminals.pagination,
              ...payload.pagination,
            },
            inProgress: false,
          },
        };
      case FETCH_TERMINAL_REQUESTS:
        return {
          ...state,
          terminalRequests: {
            ...state.terminalRequests,
            data: payload.list,
            pagination: {
              ...state.terminalRequests,
              ...payload.pagination,
            },
            inProgress: false,
          },
        };
      case ACTIVATE_TERMINAL_REQUEST:
        return {
          ...state,
          terminals: {
            ...state.terminals,
            data: payload.data,
            inProgress: false,
          },
        };
      case FETCH_ALL_TERMINAL_START_ASYNC:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: true,
          },
        };
      case FETCH_ALL_TERMINAL_END_ASYNC:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: false,
          },
        };
      default:
        return state;
    }
  },
);
